module.exports = __webpack_public_path__ + "img/prize_a2.935f204b.png";